<template>
  <div class="nav-progress" :class="{ 'is-active': navState.active }" aria-hidden="true">
    <div class="nav-progress__bar" :style="{ width: navState.progress + '%' }"></div>
  </div>
</template>

<script>
import { navState } from "@/utils/navState";

export default {
  name: "NavProgress",
  data() {
    return { navState };
  },
};
</script>

<style scoped>
.nav-progress {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  z-index: 100000;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.nav-progress.is-active {
  opacity: 1;
}

.nav-progress__bar {
  height: 100%;
  background: var(--primary-color, #ff6634);
  box-shadow: 0 0 6px color-mix(in srgb, var(--primary-color, #ff6634) 50%, transparent);
  transition: width 0.2s ease-out;
}

@media (prefers-reduced-motion: reduce) {
  .nav-progress,
  .nav-progress__bar {
    transition: none;
  }
}
</style>
